<ng-container *ngIf="isLoading; then loading else content"></ng-container>

<ng-template #loading>
  <div class="panel-title-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
  <div class="panel-dummy">
    <div class="shine"></div>
  </div>
</ng-template>

<ng-template #content>

  <div *ngIf="isCrossPoint">
    <h2 class="panel-title">{{('Modules.Licenses.List.Filter' | translate)}}</h2>

    <form class="form-container" [formGroup]="companyFormGroup">
      <app-input type="menu" (click)="openCompaniesFilterDialog()" formControlName="selectedCompany"
        label="{{ 'Modules.Licenses.List.FilterInfo' | translate}}">
      </app-input>
    </form>  
  </div>

  <div *ngIf="showLicenses()">
    <h2 class="panel-title">{{ title }}</h2>

    <app-search-bar [title]="'Components.SearchBar.Title' | translate"
    [placeholder]="'Components.SearchBar.Placeholder' | translate"
    (onSearchTextChanged)="onSearchTextChanged($event)"></app-search-bar>
  
    <p *ngIf="!expired && !expiring" class="p-formfield-info">{{ 'Modules.Licenses.List.AutoRenewalStopInfo' | translate }}</p>
  
    <ng-container *ngIf="storeLicenses?.length > 0; then licensesList else noStoreLicenses"></ng-container>
  
    <ng-template #licensesList>
      <div *ngIf="!isLoadingFilteredLicenses" class="panel no-select">
        <app-list-item *ngFor="let license of storeLicenses" [selectable]="!isCrossPoint" (onClickCallback)="onLicenseClicked(license)" [selected]="isInBasket(license)"
            [title]="getFormattedLicenseTitle(license)" [info]="getFormattedLicenseSubTitle(license)" [info2]="getLicenseInformation(license)">
        </app-list-item>
      </div>
      <div *ngIf="isLoadingFilteredLicenses">
        <mat-spinner class="spinner" diameter="28"></mat-spinner>
      </div>
    </ng-template>
  
    <ng-template #noStoreLicenses>
      <ng-container>
        <div class="panel-no-data">
          {{ (searchText.length > 0 ? 'Modules.Licenses.List.NoLicensesFiltered' : 'Modules.Licenses.List.NoData') | translate: { filter: searchText } }}          
        </div>
      </ng-container>
    </ng-template>  

  </div>
</ng-template>